import visTypeCheckers from 'types/visTypeCheckers';

// The fullscreen copy of a gadget gets its own key, so its "Load all" button
// isn't portalled into the card underneath
const buildShowAllKey = ({
  chartDef,
  dashboardGadget,
  isFullscreen,
}: {
  chartDef: VisualisationDefinitions.SingleMetricDateMatrix;
  dashboardGadget?: DashboardGadget;
  isFullscreen?: boolean;
}) => {
  const suffix = isFullscreen
    ? '-show-all-portal-fullscreen'
    : '-show-all-portal';
  if (
    dashboardGadget &&
    visTypeCheckers.isSingleMetricDateMatrix(dashboardGadget.chartDef)
  ) {
    return `${dashboardGadget.id}${suffix}`;
  }

  return `${chartDef.id}${suffix}`;
};

export default buildShowAllKey;
